const MODULE_NAME = 'gepjarmuEvjarataValidator';
import moment from 'moment';
export default angular.module(MODULE_NAME, []).directive('gepjarmuEvjarataValidator', function () {
	'ngInject';
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (scope, element, attrs, ngModelCtrl) {

			ngModelCtrl.$validators.format = function (modelValue) {
				var valid = false;
				var patter = /\d{4}-(0[1-9]|1[0-2])/;

				if (modelValue && modelValue.length == 7) {
					var regExp = new RegExp(patter);
					if (regExp.test(modelValue)) {
						valid = true;
					}
				} else {
					valid = true;
				}

				return valid;
			};

			ngModelCtrl.$validators.range = function (modelValue) {
				var valid = false;
				var patter = /\d{4}-(0[1-9]|1[0-2])/;

				if (modelValue && modelValue.length == 7) {
					var regExp = new RegExp(patter);
					if (regExp.test(modelValue)) {
						var ma = new Date();
						var gepjarmuEvjarata = moment(modelValue, 'YYYY-MM');
						if (gepjarmuEvjarata <= ma) {
							valid = true;
						}
					}
				} else {
					valid = true;
				}

				return valid;
			};

		}
	};
}).name;



// WEBPACK FOOTER //
// ./source/applications/kalkulator/eszkozkalkulator/validators/gepjarmuevjaratvalidator.js